/**
 * A single open/closed flag, optionally remembered.
 *
 * Used by `wpp::form.fieldset` and `wpp::navigation.group`, which both want the
 * same behaviour and had their own copy of it inline.
 *
 * `persistAs` is a localStorage key. Navigation groups use one because a
 * collapsed sidebar section that reopens on every page load is worse than not
 * being collapsible; a fieldset does not, because collapsing one is about the
 * form in front of you, not a standing preference.
 *
 * @param {{ open?: boolean, persistAs?: string|null }} options
 */
export default function disclosure(options = {}) {
    const initial = options.open ?? true;
    const key = options.persistAs ?? null;

    return {
        open: key ? this.$persist(initial).as(key) : initial,

        toggle() {
            this.open = ! this.open;
        },
    };
}
